import CountUp from "react-countup";
import React, { useEffect, useState } from 'react';

export default function HomeCounter() {

  const [isClient, setIsClient] = useState(false);
  useEffect(() => {
    // mark client after hydration — CountUp will only render on client
    setIsClient(true);
  }, []);
  return (
    <>
      <section className="home-counter">
        <div className="container">
          <div className="row">
            <div className="col-md-12 col-lg-4">
              <div className="counter-text">
                <h2 className="heading">Keeping it <br /> clean since <br /> 1990</h2>
              </div>
            </div>
            <div className="col-md-12 col-lg-8">
              <div className="counter-count">
                <div className="counter-count-inner">
                  <div className="row align-items-center">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number">
                            {isClient ? <CountUp start={0} end={4200} duration={7} separator="" /> : "4200"}
                          </span>
                          +</div>
                        <p>Clients Served</p>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-3 ">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number"> {isClient ? <CountUp start={0} end={5600} duration={7} separator="" /> : "5600"}  </span>
                          +</div>
                        <p>Installations done</p>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-3 ">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number"> {isClient ? <CountUp start={0} end={35} duration={7} separator="" /> : "35"}  </span>
                          +</div>
                        <p>Years of Experience</p>
                      </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-3">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number"> {isClient ? <CountUp start={0} end={700} duration={7} separator="" /> : "700"}  </span>
                          +</div>
                        <p>Team Members</p>
                      </div>
                    </div>
                    {/* <div className="col-6 col-sm-6 col-md-4">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number"> {isClient ? <CountUp start={0} end={300} duration={7} separator="" /> : "300"}  </span>
                          +</div>
                        <p>Facilities served</p>
                      </div>
                    </div> */}
                    {/* <div className="col-6 col-sm-6 col-md-4">
                      <div className="counter-text">
                        <img src="/assets/images/ecllips-images.webp" alt="Ecllips" className="ecllips-images" />
                        <div >
                          <span className="stat-number"> {isClient ? <CountUp start={0} end={44} duration={7} /> : "44"}  </span>
                          +</div>
                        <p>Global Partners</p>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
